let cscPromise = null;

export const loadCSC = () => {
  if (!cscPromise) {
    cscPromise = import('country-state-city');
  }
  return cscPromise;
};

// Common ISO-2 to Country Name mapping for instant synchronous lookup
export const COMMON_COUNTRY_MAP = {
  IN: "India",
  US: "United States",
  CN: "China",
  SG: "Singapore",
  AE: "United Arab Emirates",
  DE: "Germany",
  GB: "United Kingdom",
  JP: "Japan",
  KR: "South Korea",
  HK: "Hong Kong",
  MY: "Malaysia",
  VN: "Vietnam",
  TH: "Thailand",
  ID: "Indonesia",
  NL: "Netherlands",
  FR: "France",
  IT: "Italy",
  ES: "Spain",
  AU: "Australia",
  NZ: "New Zealand",
  CA: "Canada",
  BR: "Brazil",
  MX: "Mexico",
  ZA: "South Africa",
  BD: "Bangladesh",
  LKA: "Sri Lanka",
  LK: "Sri Lanka",
  PK: "Pakistan",
  SA: "Saudi Arabia",
  QA: "Qatar",
  KW: "Kuwait",
  OM: "Oman",
  BH: "Bahrain",
  EG: "Egypt",
  TR: "Turkey",
  BE: "Belgium",
  CH: "Switzerland",
  SE: "Sweden",
  NO: "Norway",
  DK: "Denmark",
  FI: "Finland",
  PL: "Poland",
  AT: "Austria",
  IE: "Ireland",
  PH: "Philippines",
  TW: "Taiwan"
};

export const getCountryNameByCodeSync = (code) => {
  if (!code) return "Unknown";
  const upper = code.toUpperCase();
  return COMMON_COUNTRY_MAP[upper] || null;
};

export const getCountryByCodeAsync = async (code) => {
  if (!code) return "Unknown";
  const syncName = getCountryNameByCodeSync(code);
  if (syncName) return syncName;

  try {
    const csc = await loadCSC();
    const country = csc.Country.getCountryByCode(code.toUpperCase());
    return country?.name || "Unknown";
  } catch (err) {
    console.error("Error dynamically loading country-state-city:", err);
    return "Unknown";
  }
};
